import { FusionMelcoFusionModelsUserBlank } from "melco-shared-logic";

type DisplayBlankDrawerSelectValueProps = {
  blank: FusionMelcoFusionModelsUserBlank;
};

export const DisplayBlankDrawerSelectValue: React.FC<
  DisplayBlankDrawerSelectValueProps
> = ({ blank }) => <>{blank.name}</>;
